import { render, staticRenderFns } from "./PredefinedFilter.vue?vue&type=template&id=4a50d7d0&scoped=true&"
import script from "./PredefinedFilter.vue?vue&type=script&lang=js&"
export * from "./PredefinedFilter.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedFilter.vue?vue&type=style&index=0&id=4a50d7d0&prod&scoped=true&lang=scss&"
import style1 from "./PredefinedFilter.vue?vue&type=style&index=1&id=4a50d7d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50d7d0",
  null
  
)

export default component.exports